module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Group-folders-bcfb43bcff17e199a633a86157edbf23.svg";